import ICartRepository from "@/apps/shared/buyback/core/domain/service/interface/ICartRepository";
import { Cart } from "@/apps/shared/buyback/core/domain/model/Cart";
import cartMapper from "@/apps/shared/buyback/core/infrastructure/mapper/buyback/cart/cartMapper";

const LOCALSTORAGE_KEY = "CART";

class CartLocalStorageRepository implements ICartRepository {
  getStoredAt(): number | null {
    const cartFromLocalStorage = localStorage.getItem(LOCALSTORAGE_KEY);
    if (cartFromLocalStorage === null) {
      return null;
    }

    const parsedCart = JSON.parse(cartFromLocalStorage);
    // Handle previously stored carts that don't have the storedAt property
    if (!parsedCart.storedAt) {
      return null;
    }

    return parsedCart.storedAt;
  }

  getCart(minimumCartValue: number, maxNbOfItems: number): Cart {
    const cartFromLocalStorage = localStorage.getItem(LOCALSTORAGE_KEY);
    if (cartFromLocalStorage === null) {
      throw new Error("No cart in local storage");
    }

    return cartMapper.mapCartFromString(cartFromLocalStorage, minimumCartValue, maxNbOfItems);
  }

  storeCart(cart: Cart): void {
    const storedAt = new Date().getTime();
    localStorage.setItem(
      LOCALSTORAGE_KEY,
      JSON.stringify({
        ...cart,
        storedAt,
      })
    );
  }
}

export default new CartLocalStorageRepository();
